import React, { useEffect, useState } from "react";
import api from "utils/api";
import { Line } from "react-chartjs-2";
import APIConstant from "utils/constant";
import { Box, Tab, Tabs, Typography } from "@material-ui/core";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Calendar } from "primereact/calendar";
import { SelectButton } from "primereact/selectbutton";
import moment from "moment";

const filterOptions = ["Today", "7 Days", "30 Days"];
const options = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    yAxes: [
      {
        id: "y-axis-orders", // must match dataset
        position: "left",
        ticks: { beginAtZero: true },
        scaleLabel: {
          display: true,
          labelString: "Orders",
        },
      },
      {
        id: "y-axis-revenue", // must match dataset
        position: "right",
        ticks: { beginAtZero: true },
        scaleLabel: {
          display: true,
          labelString: "Revenue (₹)",
        },
        gridLines: { drawOnChartArea: false },
      },
    ],
    xAxes: [
      {
        scaleLabel: {
          display: true,
          labelString: "Month",
        },
      },
    ],
  },
  tooltips: {
    mode: "index",
    intersect: false,
  },
};
const Dashboard = (props) => {
  const [userId, setUserId] = useState("");
  const [tabValue, setTabValue] = useState(1);
  const [bestSellingProducts, setBestSellingProducts] = useState([]);
  const [salesOverview, setSalesOverview] = useState([]);
  const [filterDate, setFilterDate] = useState("");
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [expandedRows, setExpandedRows] = useState(null);

  useEffect(() => {
    let data = localStorage.getItem("Infodata");
    let token = localStorage.getItem("Token");

    let lockstatus = localStorage.getItem("LockStatus");

    // if (lockstatus == 0) {
    if (token !== null) {
      setUserId(data);
    } else {
      props.history.push("/login");
    }
    // } else {
    //     this.props.history.push('/auth/lockscreen')
    // }
  }, []);

  useEffect(() => {
    if (userId) {
      // getGeneralDashboardAPI(userId);
      getOverviewAPI(userId);
    }
  }, [dateRange, userId, tabValue]);

  const getOverviewAPI = async (UserId) => {
    let params = {
      UserId,
      FilterDate: tabValue === 0 ? filterDate : null,
      DateRange: tabValue === 0 ? dateRange : null,
    };

    await api
      .post(APIConstant.path.GetSalesOverview, params)
      .then((response) => {
        if (response.Success === 1) {
          const chartData = {
            labels: response.Data.labels,
            datasets: [
              {
                label: "Orders",
                data: response.Data.orders,
                borderColor: "rgba(75, 192, 192, 1)",
                backgroundColor: "rgba(75, 192, 192, 0.2)",
                tension: 0.4,
                yAxisID: "y-axis-orders",
              },
              {
                label: "Revenue",
                data: response.Data.revenue,
                borderColor: "rgba(255, 99, 132, 1)",
                backgroundColor: "rgba(255, 99, 132, 0.2)",
                tension: 0.4,
                yAxisID: "y-axis-revenue",
              },
            ],
          };
          setSalesOverview(chartData);
        }
      })
      .catch((err) => {});

    await api
      .post(APIConstant.path.GetBestSellingProducts, params)
      .then((response) => {
        if (response.Success) {
          setBestSellingProducts(response.Data);
        }
      })
      .catch((err) => {});
  };

  const TabPanel = (props) => {
    const { children, value, index, ...other } = props;
    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box p={3}>{children}</Box>}
      </Typography>
    );
  };

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  const handleTabChange = (e, value) => {
    setTabValue(value);
  };

  const actionBodyTemplateSrNo = (data, props) => {
    return props.rowIndex + 1;
  };

  const rowExpansionTemplate = (data) => {
    return (
      <div className="p-3">
        <DataTable value={data.Variants} className="p-datatable-sm">
          <Column field="VariantName" header="Variant Name"></Column>
          <Column field="Size" header="Size"></Column>
          <Column field="RawQuantity" header="Qty"></Column>
          <Column field="Revenue" header="Price"></Column>
          <Column field="AveragePrice" header="Avg Price"></Column>
        </DataTable>
      </div>
    );
  };

  return (
    <div className="p-mt-2 e-main-access">
      {/* <div className="heading-area">
        <h2> Dashboard </h2>
      </div> */}
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        aria-label="simple tabs example"
      >
        <Tab label="General" {...a11yProps(0)} />
        <Tab label="Overview" {...a11yProps(1)} />
      </Tabs>

      <TabPanel className="main-card main-dashboard" value={tabValue} index={0}>
        {" "}
        <div className="custom-inputs">
          <div className="p-d-flex p-ai-center">
            <SelectButton
              className="wb-filter-dt"
              value={filterDate}
              onChange={(e) => {
                setFilterDate(e.value);
                let range = null;

                const today = moment();

                switch (e.value) {
                  case "Today":
                    range = [
                      today.startOf("day").toDate(),
                      today.endOf("day").toDate(),
                    ];
                    break;
                  case "7 Days":
                    range = [
                      moment()
                        .subtract(6, "days")
                        .startOf("day")
                        .toDate(),
                      today.endOf("day").toDate(),
                    ];
                    break;
                  case "30 Days":
                    range = [
                      moment()
                        .subtract(29, "days")
                        .startOf("day")
                        .toDate(),
                      today.endOf("day").toDate(),
                    ];
                    break;
                  default:
                    range = null;
                }

                setDateRange(range);
              }}
              options={filterOptions}
            />
            <div style={{ width: "50%" }}>
              <Calendar
                dateFormat="dd/mm/yy"
                className="p-w-100 p-mt-2"
                placeholder="Start Date - End Date"
                value={dateRange}
                selectionMode="range"
                onChange={(e) => {
                  e.stopPropagation();
                  setDateRange(e.value);
                  setFilterDate("");
                }}
              />
            </div>
          </div>
        </div>
        <div className="wb-owner-chart p-mt-3">
          <div className="p-d-flex p-ai-center">
            <p>Sales Overview</p>
          </div>
          {salesOverview ? (
            <Line data={salesOverview} options={options} />
          ) : (
            <p>No Data Found...</p>
          )}
        </div>
      </TabPanel>
      <TabPanel
        className="main-card equipment-dashboard"
        value={tabValue}
        index={1}
      >
        <div className="wayment-owner-dashboard p-mt-0">
          <div className="p-d-flex">
            <div className="p-col-12 p-md-6">
              <div className="wb-owner-chart">
                <div className="p-d-flex p-ai-center">
                  <p>Sales Overview</p>
                </div>
                {salesOverview ? (
                  <Line data={salesOverview} options={options} />
                ) : (
                  <p>No Data Found...</p>
                )}
              </div>
            </div>
            <div className="p-col-12 p-md-6">
              <div className="custom-large-wb-table wb-owner-chart p-my-2">
                <p>Best Selling Products</p>
                <hr className="p-my-2" />
                <DataTable
                  className="main-table table-td"
                  value={bestSellingProducts}
                  expandedRows={expandedRows}
                  onRowToggle={(e) => setExpandedRows(e.data)}
                  rowExpansionTemplate={rowExpansionTemplate}
                  editMode="row"
                  dataKey="MainProductId"
                  responsiveLayout="scroll"
                  emptyMessage="No records found"
                  columnResizeMode="fit"
                  scrollable={true}
                >
                  <Column expander style={{ width: "3em" }} />
                  <Column
                    field="Index"
                    header="Sr.No"
                    body={actionBodyTemplateSrNo}
                    style={{ width: "20% !important" }}
                  ></Column>
                  <Column
                    field="ItemName"
                    header="Items"
                    style={{ width: "80% !important" }}
                    body={(rowData) => {
                      const color =
                        rowData.ChangeDirection === "up"
                          ? "green"
                          : rowData.ChangeDirection === "down"
                          ? "red"
                          : "gray";
                      const icon =
                        rowData.ChangeDirection === "up"
                          ? "↑ +"
                          : rowData.ChangeDirection === "down"
                          ? "↓ -"
                          : "→";
                      return (
                        <div className="p-d-flex" style={{ gap: "3px" }}>
                          <div>
                            <div>{rowData.ItemName}</div>
                            <div className="p-d-flex">
                              <div>{rowData.TotalQuantity} sales . ₹</div>
                              <div>{rowData.Price}</div>
                            </div>
                          </div>
                          <div style={{ color }}>
                            {icon} {rowData.PercentageChange}
                          </div>
                        </div>
                      );
                    }}
                  ></Column>
                </DataTable>
              </div>
            </div>
          </div>
        </div>
      </TabPanel>
    </div>
  );
};

export default Dashboard;
